import createModel from '../lib/create_model';
import NotificationType from './notification_type';

export default createModel({
  modelName: 'UnofferedCallNotification',

  properties: {
    id: String,
    reason: String,
  },

  overrideToJs(toJs) {
    return () => ({ ...toJs(), type: NotificationType.UNOFFERED_CALL });
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/notification/unoffered_call_notification.js